import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import NumberField from "../../../Form/NumberField";
import TextField from "../../../Form/TextField";
import {
  DAYS,
  FREQUENCY_SPECS_CAP_EXPLANATION,
  FREQUENCY_SPECS_CAP_DESCRIPTION,
  TIMES_EVERY,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";

const FrequencySpecsMeta = ({ name, control, disabled = false }) => {
  const {
    watch,
    formState: { errors },
  } = useFormContext();

  const frequencySpecs = watch(name) || { maxFrequency: "", intervalDays: "" };
  const { maxFrequency, intervalDays } = frequencySpecs;

  const { t } = useTranslationApp();

  return (
    <Box>
      {/* Cap Description */}
      <Typography variant="body1" sx={{ mb: 2, display: "block" }}>
        {t(FREQUENCY_SPECS_CAP_EXPLANATION)}
      </Typography>

      {/* Frequency Values */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        <Box>
          <TextField
            name={`${name}.maxFrequency`}
            disabled={disabled}
            fullWidth
            variant="filled"
            InputProps={{
              inputComponent: NumberField,
              endAdornment: (
                <Typography variant="body2">{t(TIMES_EVERY)}</Typography>
              ),
            }}
            control={control}
            errors={errors}
            sx={{
              maxWidth: 250,
            }}
          />
        </Box>
        <Box>
          <TextField
            name={`${name}.intervalDays`}
            disabled={disabled}
            fullWidth
            variant="filled"
            InputProps={{
              inputComponent: NumberField,
              endAdornment: <Typography variant="body2">{t(DAYS)}</Typography>,
            }}
            control={control}
            errors={errors}
            sx={{
              maxWidth: 250,
            }}
          />
        </Box>
      </Box>

      {/* Description Text */}
      {maxFrequency !== "" &&
        maxFrequency !== null &&
        maxFrequency !== undefined &&
        intervalDays !== "" &&
        intervalDays !== null &&
        intervalDays !== undefined && (
          <Typography
            variant="caption"
            color="fields.placeholder"
            sx={{
              mt: 0.5,
            }}
          >
            {t(FREQUENCY_SPECS_CAP_DESCRIPTION, {
              maxFrequency: maxFrequency || 0,
              intervalDays: intervalDays || 0,
            })}
          </Typography>
        )}
    </Box>
  );
};

export default FrequencySpecsMeta;
